import { Mixit } from ".";
import { Component } from "../../helpers/compiler";

@Component({ className: 'js-mixitup' })
export class MixitComponent {
	constructor(private element: HTMLElement) {
		const multifilter = element.getAttribute('data-mixitup-multifilter') === "true";
		new Mixit(element, { multifilter: multifilter });
	}
}